import React from "react";
import { Toaster } from 'react-hot-toast';
import Routes from "./components/routes/routesContainer";

const App = () => {
  return (
    <>
      <Toaster
        position="top-right"
        reverseOrder={false}
        toastOptions={{
          duration: 4000,
          style: {
            background: '#1a1a1b',
            color: '#fff',
            border: '1px solid rgba(255, 255, 255, 0.1)'
          },
          success: {
            iconTheme: {
              primary: '#10b981',
              secondary: '#fff',
            },
          },
          error: {
            iconTheme: {
              primary: '#ef4444',
              secondary: '#fff',
            },
          },
        }}
      />
      <Routes />
    </>
  );
};

export default App;